import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div<{ integracao?: boolean }>`
  padding-top: ${({ integracao }) => (integracao ? '5%' : '12%')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.overlay};
  display: block;
  z-index: 2001;
`
export const Modal = styled.div<{ integracao?: boolean }>`
  width: 600px;
  height: ${({ integracao }) => (integracao ? '500px' : '290px')};
  background-color: ${colors.surface};
  margin: 0 auto;
  text-align: center;
  border-radius: 10px;
  padding: 30px;
`

export const DivForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  align-items: center;
  margin-top: 25px;
`

export const Form = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`

export const Label = styled.label<{ left: string; integracao?: boolean }>`
  position: absolute;
  top: ${({ integracao }) => (integracao ? '-9px' : '22px')};
  color: ${colors.grey900};
  left: ${({ left }) => left};
  padding: 0 3px;
  font-size: 12px;
  background-color: ${colors.surface};
`

export const Input = styled.input<{ width: string; integracao?: boolean }>`
  /* Transparente de proposito: o rotulo flutuante recorta a borda deste campo, e
     esse recorte so funciona se campo e container tiverem a MESMA cor. Com o campo
     preenchido, o rotulo atravessa a fronteira e vira uma caixa visivel. Campos SEM
     rotulo flutuante (busca, filtros) seguem preenchidos pela base do GlobalStyle. */
  background-color: transparent;
  width: ${({ width }) => width};
  height: 23px;
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  font-size: 14px;
  padding: 20px 20px 20px 10px;
  margin-top: ${({ integracao }) => (integracao ? '0px' : '30px')};
`
export const BtnSave = styled.button`
  margin: 0 auto;
  margin-top: 30px;
  cursor: pointer;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  border: none;
  width: 240px;
  height: 40px;
  border-radius: 16px;
`
export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const ButtonClosed = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`

export const ContainerTitleInativaOrganizacao = styled.div`
  text-align: center;
  width: 330px;
  font-size: 22px;
  font-weight: 600;
  margin: 40px auto 50px auto;
`

export const Buttons = styled.div<{ integracao?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ integracao }) => (integracao ? '700px' : '370px')};
  margin: 0 auto;
`
